import { createSelector } from '@ngrx/store';
import { selectResolvedSettingByPath, selectResolvedSettingByPathAsDuration } from '@main/settings/store/settings.selectors';
import { selectUnitEntityMap } from '@core/units/store/unit.selectors';
import { SettingValue, Unit } from '@cco/model';

const numericSettingValueAccessor = (resolvedSetting: SettingValue) => resolvedSetting?.value as number;

export const selectDefaultConcreteOutputUnitId = createSelector(
  selectResolvedSettingByPath([ 'defaultUnits', 'concreteOutput' ]),
  numericSettingValueAccessor);

export const selectDefaultConcreteOutputUnit = createSelector(selectDefaultConcreteOutputUnitId, selectUnitEntityMap, (id, entityMap) => {
  return entityMap?.[id] as Unit;
});

export const selectDefaultDensityUnitId = createSelector(
  selectResolvedSettingByPath([ 'defaultUnits', 'mixDesign', 'density' ]),
  numericSettingValueAccessor);

export const selectDefaultDensityUnit = createSelector(selectDefaultDensityUnitId, selectUnitEntityMap, (id, entityMap) => {
  return entityMap?.[id] as Unit;
});

export const selectDefaultMassUnitId = createSelector(
  selectResolvedSettingByPath([ 'defaultUnits', 'mixDesign', 'cement' ]),
  numericSettingValueAccessor);

export const selectDefaultMassUnit = createSelector(selectDefaultMassUnitId, selectUnitEntityMap, (id, entityMap) => {
  return entityMap?.[id] as Unit;
});

export const selectDefaultPriceLevelId = createSelector(
  selectResolvedSettingByPath(['pricing', 'defaultPriceLevel']),
  numericSettingValueAccessor);

export const selectDefaultGlobalDateFilterSpan =
  selectResolvedSettingByPathAsDuration(['userInterface', 'defaultGlobalDateFilterSpan']);
